<template>
  <div id="map-container">
    <div v-bind:class="{loader:true, done:!loading}" >
      <div class="indeterminate"></div>
    </div>
    <div id="route-map" v-bind:style="{ height }"></div>
  </div>
</template>

<script>
import GoogleMapsLoader from './config';
import { decodeRSA } from '../../../mixins/function';
import { TaskQueue } from '../../../mixins/taskQueue';

export default {
  name: 'MapRoutes',
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
  data() {
    return {
      clustering: [],
      google: null,
      infoWindows: [],
      map: null,
      markers: [],
      taskQueue: new TaskQueue(350),
      zoomControl: true,
    };
  },
  props: {
    lat: {
      type: Number,
      default: -33.435774,
    },
    lng: {
      type: Number,
      default: -70.660690,
    },
    locations: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '100vh',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  methods: {
    initMap() {
      if (this.map) {
        this.markers.forEach((m) => {
          m.setMap(null);
        });
        this.markers.length = 0;
      } else {
        const element = document.getElementById('route-map');
        GoogleMapsLoader.load((google) => {
          this.google = google;
          this.map = new google.maps.Map(element, {
            center: new google.maps.LatLng(this.lat, this.lng),
            zoom: 8,
            zoomControl: this.zoomControl,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_RIGHT,
            },
          });
          this.controlDiv = document.createElement('div');
          this.controlDiv.style.display = 'none';
          const controlUI = document.createElement('div');
          controlUI.style.backgroundColor = '#707070';
          controlUI.style.border = '2px solid #707070';
          controlUI.style.borderRadius = '3px';
          controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
          controlUI.style.cursor = 'pointer';
          controlUI.style.marginBottom = '22px';
          controlUI.style.marginTop = '10px';
          controlUI.style.textAlign = 'center';
          controlUI.style.width = '200px';
          this.controlDiv.appendChild(controlUI);
          // Set CSS for the control interior.
          const controlText = document.createElement('div');
          controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
          controlText.style.fontSize = '16px';
          controlText.style.color = 'white';
          controlText.style.lineHeight = '20px';
          controlText.innerHTML = 'Cargando Rutas';
          controlUI.appendChild(controlText);
          this.controlDiv.index = 1;
          this.controlPB = document.createElement('div');
          this.controlPB.style.backgroundColor = '#a7d500';
          this.controlPB.style.height = '10px';
          this.controlPB.style.width = '6%';
          controlUI.appendChild(this.controlPB);
          this.controlDiv.index = 1;
          this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.controlDiv);
        });
      }
    },
    addEvent() {
      GoogleMapsLoader.load((google) => {
        const map = document.getElementById('route-map');
        const infoWindow = new google.maps.InfoWindow({
          content: '',
        });
        this.markers.forEach((element) => {
          let contentString;
          if (element.pointData.customer) {
            contentString = `<div class="infowindowContainer">
            <p class="titleStyle" style="text-transform: capitalize;">${decodeRSA(element.pointData.customer.full_name)}</p>
            <p class="addressStyle" style="text-transform: capitalize;">${decodeRSA(element.pointData.raw_address)}, ${element.pointData.point.street.commune.name}</p>
            <p class="nOrderStyle"><span>Nº Orden: ${element.pointData.suborders[0].code}</span></p>
            <p class="numberStyle"><i class="fa fa-mobile"></i> ${decodeRSA(element.pointData.customer.phone)}</p>
            <p class="genericTitle"><span class="bold">PRODUCTOS:</span></p>`;
            element.pointData.suborders[0].packages.forEach((product) => {
              contentString += `<p class="productStyle">${product.description}</p>`;
            });
            contentString += '</div>';
          } else if (!element.pointData.customer) {
            contentString = `<div><p class="ctName">${element.pointData.name}</p></div>`;
          }
          element.addListener('click', () => {
            infoWindow.close();
            infoWindow.setContent(contentString);
            infoWindow.open(map, element);
          });
        });
      });
    },
    addMarkers() {
      this.markers.forEach((m) => {
        m.setMap(null);
      });
      this.markers.length = 0;
      if (this.routes) {
        this.routes.forEach((r) => {
          r.setMap(null);
        });
        this.routes.length = 0;
      }
      const bounds = new this.google.maps.LatLngBounds();
      const tramos = [];
      for (let i = 0; i < this.locations.length; i += 1) {
        if (!this.locations[i].delivery_points) {
          // eslint-disable-next-line no-continue
          continue;
        }
        const color = this.getRandomColor();
        const route = this.locations[i];
        let tempMarker = null;
        if (route.transfer_centers_id !== null) {
          tempMarker = new this.google.maps.Marker({
            title: 'CTT',
            position: new this.google.maps.LatLng(route.transfer_center.point.latitude,
              route.transfer_center.point.longitude),
            map: this.map,
            icon: {
              // eslint-disable-next-line global-require
              url: `${require('../../../assets/img/depot.png')}`,
              anchor: new this.google.maps.Point(13, 20),
            },
            pointData: route.transfer_center,
          });
        } else {
          tempMarker = new this.google.maps.Marker({
            title: 'CD',
            position: new this.google.maps.LatLng(route.distribution_center.point.latitude,
              route.distribution_center.point.longitude),
            map: this.map,
            icon: {
              // eslint-disable-next-line global-require
              url: `${require('../../../assets/img/depot.png')}`,
              anchor: new this.google.maps.Point(13, 20),
            },
            pointData: route.distribution_center,
          });
        }
        this.markers.push(tempMarker);
        bounds.extend(tempMarker.getPosition());
        for (let j = 0; j < this.locations[i].delivery_points.length; j += 1) {
          const tempDP = this.locations[i].delivery_points[j];
          tempMarker = new this.google.maps.Marker({
            title: `${(tempDP.route_position !== null) ? tempDP.route_position + 1 : 'LE'}`,
            // eslint-disable-next-line max-len
            position: new this.google.maps.LatLng(tempDP.point.latitude + this.checkIfItsEqual(tempDP.point.latitude, tempDP.point.longitude), tempDP.point.longitude),
            label: `${(tempDP.route_position !== null) ? tempDP.route_position + 1 : 'LE'}`,
            map: this.map,
            // eslint-disable-next-line max-len,global-require
            icon: `${(tempDP.route_position !== null) ? require('../../../assets/img/green_marker_shadow.png') : require('../../../assets/img/purple_marker.png')}`,
            pointData: tempDP,
          });
          this.markers.push(tempMarker);
          bounds.extend(tempMarker.getPosition());
        }
        const splitRoute = this.createSplitRoutes(this.locations[i]);
        if (splitRoute.length > 0) {
          this.controlDiv.style.display = 'block';
        }
        // eslint-disable-next-line no-loop-func
        splitRoute.forEach((r) => {
          tramos.push({ color, path: r });
        });
      }
      this.map.fitBounds(bounds);
      // show lines
      const self = this;
      tramos.forEach((p, index) => {
        this.taskQueue.enqueue().then(() => {
          const r = p.path;
          const { color } = p;
          const options = {
            provideRouteAlternatives:false,
            optimizeWaypoints :true,
            unitSystem: this.google.maps.UnitSystem.METRIC,
            drivingOptions:{
              departureTime: new Date(Date.now()),
              trafficModel: 'optimistic'
            },
            travelMode: 'DRIVING',
            origin: r.origin,
            destination: r.destination,
            waypoints: r.waypoints,
          };
          if (!self.directionService) {
            self.directionService = new self.google.maps.DirectionsService();
          }
          self.directionService.route(options, (response, status) => {
            if (status === 'OK') {
              if (self.routes === undefined) {
                self.routes = [];
              }
              self.infoWindows.push(new self.google.maps.InfoWindow());
              self.routes.push(new self.google.maps.DirectionsRenderer({
                preserveViewport: true,
                draggable: false,
                map: self.map,
                directions: response,
                infoWindow: self.infoWindows[index],
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: color,
                  strokeOpacity: 0.8,
                  strokeWeight: 3,
                },
              }));
            } else {
              self.$notify.error({
                title: 'Error',
                message: 'Problemas al visualizar la ruta',
              });
            }
          });
          this.controlPB.style.width = `${((index + 1) / tramos.length) * 100}%`;
          if (index + 1 === tramos.length) {
            this.controlDiv.style.display = 'none';
            this.controlPB.style.width = '0%';
          }
        });
      });
    },
    createSplitRoutes(route) {
      // eslint-disable-next-line max-len
      const latOrigin = route.transfer_centers_id ? route.transfer_center.point.latitude : route.distribution_center.point.latitude;
      // eslint-disable-next-line max-len
      const lonOrigin = route.transfer_centers_id ? route.transfer_center.point.longitude : route.distribution_center.point.longitude;
      const lastPoint = route.delivery_points.filter(
        dp => dp.route_position !== null,
      ).sort((a, b) => b.route_position - a.route_position)[0];
      if (route.delivery_points.length <= 20 && lastPoint) {
        return [{
          origin: new this.google.maps.LatLng(latOrigin, lonOrigin),
          destination: new this.google.maps.LatLng(
            lastPoint.point.latitude,
            lastPoint.point.longitude,
          ),
          waypoints: route.delivery_points.filter(point => point.route_position !== null).sort(
            (pA, pB) => pA.route_position - pB.route_position,
          ).map(point => ({
            location: new this.google.maps.LatLng(
              point.point.latitude,
              point.point.longitude,
            ),
            stopover: true,
          })),
        }];
      }
      let splits = [];
      const dps = route.delivery_points.filter(
        dp => dp.route_position !== null,
      ).sort((a, b) => a.route_position - b.route_position);
      let twenties = [];
      for (let i = 0; i < dps.length; i += 1) {
        twenties.push(dps[i]);
        if (twenties.length === 20) {
          splits.push(twenties);
          twenties = [];
        }
      }
      if (twenties.length > 0) {
        splits.push(twenties);
      }
      const semiroute = [];
      splits = splits.filter(s => s.length > 0);
      for (let i = 0; i < splits.length; i += 1) {
        // eslint-disable-next-line max-len)
        semiroute.push({
          origin: new this.google.maps.LatLng(
            // eslint-disable-next-line max-len,no-undef
            i === 0 ? latOrigin : splits[i - 1][splits[i - 1].length - 1].point.latitude,
            // eslint-disable-next-line max-len
            i === 0 ? lonOrigin : splits[i - 1][splits[i - 1].length - 1].point.longitude,
          ),
          destination: new this.google.maps.LatLng(
            // eslint-disable-next-line max-len
            i + 1 === splits.length ? lastPoint.point.latitude : splits[i + 1][0].point.latitude,
            // eslint-disable-next-line max-len
            i + 1 === splits.length ? lastPoint.point.longitude : splits[i + 1][0].point.longitude,
          ),
          waypoints: splits[i].sort(
            (pA, pB) => pA.route_position - pB.route_position,
          ).map(point => ({
            location: new this.google.maps.LatLng(
              point.point.latitude,
              point.point.longitude,
            ),
            stopover: true,
          })),
        });
      }
      return semiroute;
    },
    checkIfItsEqual(lat, lng) {
      for (let i = 0; i < this.markers.length; i += 1) {
        // eslint-disable-next-line max-len
        if (this.markers[i].pointData.point.latitude === lat && this.markers[i].pointData.point.longitude === lng) {
          return 0.0000500;
        }
      }
      return 0;
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i += 1) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  mounted() {
    this.initMap();
  },
  watch: {
    locations: function getRoutes() {
      this.taskQueue.cancel();
      if (this.locations.length > 0) {
        this.addMarkers();
        this.addEvent();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #routeMap {
    width: 100%;
    height: 100vh;
    z-index: 1;
  }
  .infowindowContainer{
    width: 350px!important;
    height: 200px!important;
    text-align: left!important;
    color: #707070!important;
  }
  .titleStyle {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    text-transform: capitalize;
  }
  .addressStyle {
    font-size: 14px;
    font-weight: normal;
    margin: 0;
  }
  .ctName {
    font-size: 14px;
    font-weight: 800;
    margin: 0;
  }
  .nOrderStyle  {
    margin: 5px 0;
  }
  .nOrderStyle span {
    background-color: #9B9B9B;
    color: #FFFFFF;
    font-weight: bold;
    padding: 2px 5px;
    display: inline-block;
  }
  .numberStyle {
    font-size: 13px;
    display: inline-block;
    margin: 0;
  }
  .descriptionStyle {
    margin: 0;
  }
  .genericTitle {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .fa.fa-mobile {
    font-size: 20px;
    margin: 0 5px;
    vertical-align: sub;
    color: #A0BE03;
  }
  .productStyle {
    margin: 5px;
  }
  .productStyle::before {
    content: "• ";
    color: #A0BE03;
  }
  .loader{
    position: relative;
    height: 4px;
    display: block;
    width: 100%;
    background-color: #acece6;
    overflow: hidden;
  }
  .loader.done{
    display: none !important;
  }
  .loader .indeterminate:before {
    content: '';
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    -webkit-animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
  }
  .loader .indeterminate{
    background-color: #26a69a;
  }
  .loader .indeterminate:after {
    content: '';
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    -webkit-animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    -webkit-animation-delay: 1.15s;
    animation-delay: 1.15s;
  }
  @keyframes indeterminate {
    0% {
      left: -35%;
      right:100%;
    }
    60% {
      left: 100%;
      right: -90%;
    }
    100% {
      left: 100%;
      right: -90%;
    }
  }

  @keyframes indeterminate-short {
    0% {
      left: -200%;
      right: 100%;
    }
    60% {
      left: 107%;
      right: -8%;
    }
    100% {
      left: 107%;
      right: -8%;
    }
  }
</style>
